import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  npsSurvey: [],
  setNpsSurvey: {},
};

export default {
  state,
  actions,
  getters,
  mutations,
};
